import React, { FC } from "react";

import { useAppSelector } from "hooks/store";

import { interfaceElementsSelector } from "store/slices/themeSlice";

import { INTERFACE_ELEMENTS } from "themes/constants";

import { FlatButton } from "../ui";
import { buttonList } from "../../utils/data";

import styles from "./index.module.css";

const ConnectWithUs: FC = () => {
  const interfaceElements = useAppSelector(interfaceElementsSelector);

  const renderIconList = buttonList.map((item, index) => (
    <a key={index} href={item.link} target="_blank" rel="noreferrer">
      <FlatButton icon={item.icon} title={item.label} />
    </a>
  ));

  return (
    <>
      {interfaceElements.includes(INTERFACE_ELEMENTS.CONTACTS) && (
        <div className={styles.container}>
          <div className={styles.title}>
            <h1>Оставайтесь с нами на связи:</h1>
          </div>
          <div className={styles.iconContainer}>{renderIconList}</div>
        </div>
      )}
    </>
  );
};

export default ConnectWithUs;
